// extracted by mini-css-extract-plugin
export default {"addIcon":"control_addIcon__nM7aO"};